(function () {
    "use strict";

    angular
        .module("webcomm")
        .config([
            "$provide", "loggerProvider", function($provide, loggerProvider) {
                // Use the `decorator` solution to substitute or attach behaviors to
                // original service instance; @see angular-mocks for more examples....
                let logProvier = loggerProvider.$get();
                let logLevel = getLoggingLevel();

                let loggingLevels = {
                    none: [],
                    error: ['error'],  
                    debug: ['debug', 'log', 'warn', 'error'],   
                    info: ['debug', 'log', 'warn', 'error', 'info']     
                };

                $provide.decorator('$log', [
                    "$delegate", function($delegate) {
                        let levels = ['debug', 'log', 'warn', 'info', 'error'];
                        for (let level of levels)
                            attach($delegate, level);

                        return $delegate;
                    }
                ]);

                function attach(log, level) {
                    // Save the original $log['level']()

                    var fn = log[level];
                    //console.log(level, fn);

                    if (isLevelEnabled(level)) {
                        log[level] = function (...args) {
                            let now = new Date();
                            //args[0] = `${now} - ${args[0]}`;
                            logProvier.log(level, now, ...args);
                            fn(...args);
                        };
                    } else {
                        log[level] = function() {} // do nothing :)
                    }
                    
                    log[level].logs = []; // required for angularmocks
                }

                function isLevelEnabled(level) {
                    let enabledLevels = loggingLevels[logLevel];
                    return enabledLevels.indexOf(level) !== -1;
                }

                function getLoggingLevel() {
                    // 'webcomm_logging_level' is a global - it comes directly from index.html 
                    return webcomm_logging_level === 'LOGGING_LEVEL_PLACEHOLDER' ? 'info' : webcomm_logging_level;
                }
            }
        ])
        .provider('logger', function() {
            let maxLogLength = 5000;
            let logMessages = [];
            //console.error("logger initialized");

            this.$get = function() {
                return {
                    log(level, date, ...args) {
                        logMessages.push({ level, date, args });
                        //console.info("log length: " + logMessages.length);
                        if (logMessages.length > maxLogLength)
                            logMessages.shift();
                    },

                    get messages() {
                        //console.info("getting log: " + logMessages.length);
                        return logMessages;
                    }
                }
            }
        });

})();